//階段名稱
export const GetStageName = (state) => {
  if (!state) return "未發出";
  else if (state === "0") return "未上傳";
  else if (state === "1") return "待採購審核";
  else if (state === "3") return "待品保審核";
  else if (state === "4") return "待品保/研發審核";
  else if (state === "9") return "結案";
  else if (state === "-1") return "無效";
  else if (state === "-2") return "中止";
};

//簽核紀錄狀態名稱
export const GetLogName = (state) => {
  if (state === "-2") return "已中止";
  else if (state === "-1") return "退回";
  else if (state === "P") return "PASS";
  else if (state === "") return "已上傳";
  else if (state === "0") return "已發出";
  else if (state === "1") return "已簽核";
};

//簽核狀態名稱
export const GetSignName = (state) => {
  if (state === "0") return "未簽核";
  else if (state === "1") return "已簽核";
};
